import React, { useEffect } from "react";
import "./Privacy_policy.css";
import Common_title from "../common-components/common-title/Common_title";

const Privacy_policy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="Privacy_policy">
      <div className="container">
        <Common_title subtitle="Privacy Policy" />

        <div className="white_card">
          <p className="point_title">Effective Date: 29.04.2026</p>
          <p className="descn_text">
            Loconex (“we”, “our”, or “us”) respects your privacy and is
            committed to protecting your personal information. This Privacy
            Policy explains how we collect, use, store, and share your
            information when you use the Loconex mobile application (“App”) and
            related services.
          </p>

          <br />

          <p className="point_title">1. Information We Collect</p>

          <p className="descn_text">
            a. Personal Information We may collect your name, phone number,
            email address, profile photo, address, and business details (for
            vendors).
          </p>
          <p className="descn_text">
            b. Transaction Information We collect information related to orders,
            purchases, and service requests made through the app.
          </p>

          <p className="descn_text">
            c. Device & Usage Information We may collect device information such
            as IP address, device type, operating system, and app usage data.
          </p>

          <p className="descn_text">
            d. Location Information With your permission, we may collect your
            location to provide location-based services.
          </p>

          <p className="point_title">2. How We Use Your Information</p>

          <p className="descn_text">We use your information to:</p>

          <ul className="descn_text">
            <li>Provide and improve our services</li>
            <li>Process transactions and manage orders</li>
            <li>Communicate updates, offers, and notifications</li>
            <li>Personalize user experience</li>
            <li>Ensure security and prevent fraud</li>
            <li>Comply with legal obligations</li>
          </ul>

          <p className="point_title">3. Sharing of Information</p>

          <p className="descn_text">
            We do not sell your personal information. We may share your
            information with:
          </p>

          <ul className="descn_text">
            <li>Service providers and payment partners</li>
            <li>Legal authorities if required by law</li>
            <li>Business partners in case of merger or acquisition</li>
          </ul>

          <p className="point_title">4. Data Retention</p>

          <p className="descn_text">
            We retain your data only as long as necessary to provide services
            and comply with legal requirements.
          </p>
          <p className="point_title">5. User Rights</p>
          <p className="descn_text">You have the right to:</p>

          <ul className="descn_text">
            <li>Access or update your information</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of promotional communications</li>
            <li>Disable location access anytime</li>
          </ul>

          <p className="point_title">6. Data Security</p>

          <p className="descn_text">
            We use appropriate security measures to protect your data. However,
            no system is completely secure
          </p>

          <p className="point_title">7. Children’s Privacy</p>

          <p className="descn_text">
            Loconex does not knowingly collect data from children under 13 years
            of age.
          </p>

          <p className="point_title">8. Third-Party Services</p>

          <p className="descn_text">
            Our app may contain links to third-party services. We are not
            responsible for their privacy practices.
          </p>
          <p className="point_title">9. Changes to This Policy</p>

          <p className="descn_text">
            We may update this Privacy Policy from time to time. Updates will be
            posted within the app.
          </p>
          <p className="point_title">10. Contact Us</p>

          <p className="descn_text">
            If you have any questions about this Privacy Policy, please contact
            us: Phone: +91 6262171723
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy_policy;
